import React from 'react';
import { BigPieChart, FIUsersBreakDownTable } from '../components.js';

class FIUsersSub extends React.Component {

	constructor(props) {
		super(props);

		this.getFIUserData = this.getFIUserData.bind(this);

		this.state = { fi : {data :{}, dataError: false}};
	}

	componentDidMount() {
		
		if(this.state.fi.data !== null && Object.keys(this.state.fi.data).length === 0 && this.state.fi.dataError === false) {
			this.getFIUserData();
		}
	}

	getFIUserData() {
		var component = this;

		var callback = function(response) {
			if(response.detail !== "Report generated") {
				component.setState({fi : {data: response.data, dataError : response.detail}});
			}
			else {
				for(var i = 0; i !== response.data.fidata.length; i++) {
					var perc = response.data.fidata[i].percentage.toString();
					response.data.fidata[i].percentage = perc.slice(0, (perc.indexOf(".") + 3)) + '%';
				}
				component.setState({fi : {data : response.data, dataError: false}});
			}
		};

		window._fiSponsor.getFIUserData(callback);
	}

	render() {
		if(window.app.version.indexOf('demo') > -1)  {
			return (
				<div className="Demo-FIUsersSub">
					<img src={process.env.PUBLIC_URL + 'images/FIBreakDownDemo.png'} style={{width: '100%', height: 'auto'}} alt='breakdown demo images' />
				</div>
			);
		}
		/*const fiContainerSize = {
			width: (this.props.size) ? this.props.size.width : '45.5vmin',
			height: (this.props.size) ? this.props.size.height : '30vmin'
		};*/

  		return (
  			<div className='FIUsersSub'>
  				<BigPieChart fi={this.state.fi} />
  				<FIUsersBreakDownTable list={this.state.fi.data.fidata} />
  			</div>
  		);
	}
}

export default FIUsersSub;








